import { Node } from "../types";
import useListActions from "./useListActions";

function useBulkActions(initial: string[] = []) {
  const {
    add,
    isSelected,
    listElements,
    remove,
    reset,
    set,
    toggle
  } = useListActions<string>(initial);

  function toggleAll(items?: Node[], selected?: number, limit?: number) {
    if (!items || !Array.isArray(items)) {
      return;
    }
    const allItems = items.slice(0, limit ?? items.length).map(item => item.id);
    reset();
    if (selected !== allItems.length) {
      set(allItems);
    }
  }

  return {
    add,
    isSelected,
    listElements,
    remove,
    reset,
    toggle,
    toggleAll
  };
}
export default useBulkActions;
